import { Component, type ReactNode } from 'react'

/** The lazy force-graph chunk (or its first paint) failed: say so and offer a retry. */
export class GraphErrorBoundary extends Component<{ children: ReactNode; onRetry: () => void }, { failed: boolean }> {
  override state = { failed: false }
  static getDerivedStateFromError() {
    return { failed: true }
  }
  override render() {
    if (!this.state.failed) return this.props.children
    return (
      <div className="bui-alert bui-alert-error" role="alert">
        <span className="bui-alert-mark">✕</span>
        <span>
          <span className="bui-alert-title">Graph failed to load</span>
          <button
            type="button"
            className="bui-btn bui-btn-ghost bui-btn-sm"
            onClick={() => {
              this.setState({ failed: false })
              this.props.onRetry()
            }}
          >
            Retry
          </button>
        </span>
      </div>
    )
  }
}
